import { render } from "./IconInsta.vue?vue&type=template&id=95bf1f6a"
import script from "./IconInsta.vue?vue&type=script&lang=js"
export * from "./IconInsta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__